/**
 * Product page helpers (docs/page-specs/product.md):
 *
 * 1. Publishes the custom `delivery_estimate_shown` event through Shopify's
 *    analytics API (Web Pixels custom events, docs/09) with the day offset the
 *    delivery line rendered with (`data-delivery-offset`), once per page.
 *    `product_viewed` and `product_added_to_cart` come from Dawn's standard
 *    events (product-component and product-form.js), not from here.
 * 2. Opens the specification accordion on desktop (it renders collapsed so
 *    mobile shows it closed without a layout shift).
 */
(() => {
  const publishDeliveryEstimate = (attempt = 0) => {
    const line = document.querySelector('[data-delivery-offset]');
    if (!line) return;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') {
      if (attempt < 10) window.setTimeout(() => publishDeliveryEstimate(attempt + 1), 500);
      return;
    }
    const productInfo = line.closest('product-info');
    publish('delivery_estimate_shown', {
      offset_days: Number.parseInt(line.dataset.deliveryOffset, 10),
      product_id: productInfo?.dataset.productId || null,
      text: [...line.querySelectorAll('p')].map((p) => p.textContent.trim()).join(' / ') || line.textContent.trim(),
    });
  };

  const openDesktopAccordions = () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('details[data-open-desktop]').forEach((details) => {
      details.open = true;
    });
  };

  const init = () => {
    openDesktopAccordions();
    publishDeliveryEstimate();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
